
const UTIL = {
  // 异常提示
  handleWarn (response) {
    response.data = response.data || {}
    // const statusCode = response.data.code || response.status || 'None'
    const errorMsg = response.data.msg || '请求服务器时发生错误';
    console.log(errorMsg);
    // if (response.data.code === '401') {
    //   router.replace({path: '/login'})
    // }
  },
  // 异常处理
  handleError (error) {
    if (error.response) {
      const code = error.response.status;
      switch (code) {
        case 401: {
          // router.replace({path: '/login'})
          break
        }
        case 403: {
          // router.replace({path: '/login'})
          break
        }
        default: {
          console.error(error)
        }
      }
      this.handleWarn(error.response)
    } else {
      const errorMsg = error.message || '请求服务器时发生错误';
      console.log(errorMsg);
    }
  }
}

export const responseHandler = response => {
  if (!response.data.success) {
    UTIL.handleWarn(response)
  }
}

export const errorHandler = error => {
  UTIL.handleError(error)
}
